export default __webpack_public_path__ + "static/media/bookmark-icon-color.db019a0c.svg";